import { render } from "./SureOrder.vue?vue&type=template&id=49a06668&scoped=true"
import script from "./SureOrder.vue?vue&type=script&lang=js"
export * from "./SureOrder.vue?vue&type=script&lang=js"

import "./SureOrder.vue?vue&type=style&index=0&id=49a06668&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-49a06668"

export default script